/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PackagePaymentHistory from './package-payment-history';
import PackagePaymentHistoryDetail from './package-payment-history-detail';
import PackagePaymentHistoryUpdate from './package-payment-history-update';
import PackagePaymentHistoryDeleteDialog from './package-payment-history-delete-dialog';

const PackagePaymentHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PackagePaymentHistory />} />
    <Route path="new" element={<PackagePaymentHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<PackagePaymentHistoryDetail />} />
      <Route path="edit" element={<PackagePaymentHistoryUpdate />} />
      <Route path="delete" element={<PackagePaymentHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PackagePaymentHistoryRoutes;
